import React from 'react';
import './TextEditor.css';

const $ = window.$;
const tinymce = window.tinymce;

function parseHtml(html) {
  const el = $('<html>');
  el.html(html);
  return $('body', el).html().trim();
}

class TextEditor extends React.Component {
  constructor(props) {
    super(props);
    this.eId = props.id || Math.round(Math.random()*1000000);
  }

  initTextEditor() {
    const { content, onChange, printMode } = this.props;
    const id = this.eId;

    this.$dummy = $(this.refs.dummy);

    this.$dummy.before(
      `<div id="content_${id}" class="text-editor-content"></div><textarea id="textarea_${id}">${content || ''}</textarea>`
    );

    const a = tinymce.init({
      selector: `#textarea_${id}`,
      height : 160,
      plugins: [
        "save advlist autolink autosave link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "table contextmenu directionality emoticons template textcolor paste fullpage textcolor"
      ],
      toolbar1: "save | undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | styleselect formatselect fontselect fontsizeselect",
			toolbar2: "ltr rtl | cut copy paste | searchreplace | bullist numlist | outdent indent | link unlink | forecolor backcolor | table | hr removeformat | subscript superscript | print fullscreen | spellchecker",
      menubar: false,
      statusbar : false,
      toolbar_items_size: 'small',
      save_onsavecallback: (editor) => {
        const content = parseHtml(editor.getContent());
        onChange(content);
        return true;
      }
    });

    const $content = $(`#content_${id}`);

    if (printMode) {
      // hide the text editor
      $content.html(content);
      $content.next().hide();
    } else {
      // hide the printable content div
      $content.hide();
    }
  }

  destroyTextEditor() {
    // clean up the plugin mess when the component unmounts
    tinymce.get(`textarea_${this.eId}`).off();
    tinymce.remove(`#textarea_${this.eId}`);
    this.$dummy.prevAll().remove();
  }

  shouldComponentUpdate(nextProps) {
    return this.props.content !== nextProps.content;
  }

  componentDidMount() {
    this.initTextEditor();
  }

  componentWillUnmount() {
    this.destroyTextEditor();
  }

  render() {
    return (
      <div>
        <div ref="dummy" />
      </div>
    );
  }
}

export default TextEditor;



// WEBPACK FOOTER //
// ./src/components/TextEditor/TextEditor.js